import { useRef, useState } from "react";
import { notify } from "../../common/Toast";
import Button from "../../common/Button";
import { LiaSearchPlusSolid, LiaSearchSolid } from "react-icons/lia";
import { MdClose } from "react-icons/md";
import Table from "../../common/Table";
import Loader from "../../common/Loader";
import { NalcoRateAPI } from "../../utlis/apiService";
import { RegistryHeader } from "../../common/Shared";

const NalcoMaster = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [isNalcoData, setIsNalcoData] = useState([]);
  const tableScrollRef = useRef(null);

  const handleFetchNalcoRate = async () => {
    setLoading(true);
    try {
      const res = await NalcoRateAPI.getAllNalcoPrice();
      setIsNalcoData(res.data || []);
    } catch (error) {
      notify("Error fetching Nalco Rate", "error");
    }
    setLoading(false);
  };

  const handleFetchIngotRate = async () => {
    setLoading(true);
    try {
      const res = await NalcoRateAPI.getAllIngotPrice();
      setIsNalcoData(res.data || []);
    } catch (error) {
      notify("Error fetching Ingot Rate", "error");
    }
    setLoading(false);
  };

  const filteredData = isNalcoData.filter((row) =>
    Object.values(row)?.some((val) =>
      String(val).toLowerCase().includes(searchQuery.toLowerCase()),
    ),
  );

  return (
    <>
      <div className="flex flex-col h-full bg-white font-plus">
        <RegistryHeader title="Nalco & Ingot Price Master">
          <div className="relative w-full sm:w-80 group">
            <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none group-focus-within:text-primary">
              <LiaSearchSolid size={18} className="text-gray-400 transition-colors" />
            </div>
            <input
              type="text"
              placeholder="Search by PRODUCT OR DATE..."
              className="block w-full pl-12 pr-10 py-3 bg-gray-50 border border-gray-200 text-gray-900 text-[11px] font-black uppercase tracking-[2px] focus:border-primary focus:bg-white focus:outline-none transition-all placeholder:text-gray-300"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            {searchQuery && (
              <button
                onClick={() => setSearchQuery("")}
                className="absolute inset-y-0 right-0 pr-4 flex items-center text-gray-400 hover:text-red-500 transition-colors"
              >
                <MdClose size={18} />
              </button>
            )}
          </div>

          <div className="flex items-center gap-2">
            <button
              onClick={handleFetchNalcoRate}
              className="bg-primary text-white font-bold text-[10px] uppercase tracking-[3px] px-6 py-3 border border-primary hover:bg-[#2c5ebc] transition-all"
            >
              FETCH NALCO RATE
            </button>
            <button
              onClick={handleFetchIngotRate}
              className="bg-black text-white font-bold text-[10px] uppercase tracking-[3px] px-6 py-3 border border-black hover:bg-gray-800 transition-all"
            >
              FETCH INGOT RATE
            </button>
          </div>
        </RegistryHeader>

        <div className="px-8 pt-0 pb-4 flex-1 overflow-hidden flex flex-col">
          <div
            ref={tableScrollRef}
            className="relative overflow-auto border border-gray-200 bg-white flex-1"
          >
            {loading && <Loader centered />}
            {filteredData.length > 0 ? (
              <Table
                columns={[
                  { key: "logDate", label: " LOG DATE" },
                  { key: "productCode", label: " PRODUCT CODE" },
                  { key: "nalcoPrice", label: " NALCO PRICE" },
                  { key: "fileName", label: " FILE NAME" },
                ]}
                data={filteredData}
                showActions={false}
                tableClassName="text-[12px] font-bold"
              />
            ) : (
              <div className="flex flex-col items-center justify-center h-full text-gray-400 gap-4">
                <span className="text-[10px] font-black uppercase tracking-[2px]">Add fetch to view data logs</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default NalcoMaster;
